import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { PagedPayload } from '../models/paged-payload';
import { UserNotification } from '../models/user-notification';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  constructor(
    private http: HttpClient,
    @Inject('env') private env: any
  ) {}

  public create(notification: UserNotification): Observable<any> {
    return this.http.post<any>(`${this.env.apiUrlRoot}/Notifications/Create`, notification);
  }

  public dismiss(id: number): Observable<void> {
    return this.http.post<void>(`${this.env.apiUrlRoot}/Notifications/Dismiss`, id);
  }

  public dismissAll(userId: string): Observable<void> {
    return this.http.post<void>(`${this.env.apiUrlRoot}/Notifications/DismissAll`, { userId });
  }

  public getUserNotifications(
    userId: string,
    isDismissed: boolean,
    pageNum: number,
    pageSize: number
  ): Observable<PagedPayload<UserNotification>> {
    let params = new HttpParams();

    params = params.set('userId', userId);
    params = params.set('isDismissed', isDismissed.toString());
    params = params.set('pageNum', pageNum.toString());
    params = params.set('pageSize', pageSize.toString());

    return this.http.get<PagedPayload<UserNotification>>(`${this.env.apiUrlRoot}/Notifications`, {
      params
    });
  }

  public markAsRead(id: number) {
    this.http.post<any>(`${this.env.apiUrlRoot}/Notifications/Read`, id).subscribe();
  }
}
